// eslint:disable: max-line-length
import * as React from 'react';

/**
 * Prevents a component from rendering to the VDOM if param @fn returns falsy
 *
 * @param Component 
 */
export const withConditionalRender = (
  Component: React.ComponentClass<any>,
  fn: (props: any) => boolean
) => (props: any) => (
  fn(props) !== true ? 
  
    props.noConditionalRender ? 
      <Component {...props} label={{visible:false}} visible={false}>{null}</Component> 
    : 
      null

    : 
      <Component {...props} />);
